import { useState } from "react";
import { motion } from "framer-motion";
import { Menu, X } from "lucide-react";

const links = [
  { label: "Manifesto", href: "#manifesto", id: "manifesto" },
  { label: "Services", href: "#services", id: "services" },
  { label: "Roster", href: "#roster", id: "roster" },
  { label: "Listen", href: "#listen", id: "listen" },
  { label: "Work", href: "#work", id: "work" },
  { label: "Merch", href: "#merch", id: "merch" },
];

export const Nav = () => {
  const [open, setOpen] = useState(false);
  const go = (id) => {
    setOpen(false);
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <motion.header
      data-testid="site-nav"
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.9, delay: 0.2, ease: [0.22, 1, 0.36, 1] }}
      className="fixed top-0 left-0 right-0 z-50 backdrop-blur-xl bg-[#FDFBF7]/80 border-b border-[#2D1A13]/10"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 h-[72px] flex items-center justify-between">
        <button
          data-testid="nav-logo"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="flex items-center gap-2 group"
        >
          <span className="h-9 px-3.5 rounded-full bg-black flex items-center overflow-hidden group-hover:scale-105 transition-transform duration-300">
            <img src="/assets/logo.png" alt="Ice Cream Social logo" className="h-[15px] w-auto" />
          </span>
          <span className="font-serif-display font-bold text-lg tracking-tight">Ice Cream Social</span>
        </button>

        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-link-${l.id}`}
              onClick={() => go(l.id)}
              className="text-xs font-semibold uppercase tracking-[0.2em] text-[#2D1A13]/70 hover:text-[#2D1A13] transition-colors duration-300 relative after:absolute after:left-0 after:-bottom-1 after:h-[2px] after:w-0 after:bg-[#FF8E9E] hover:after:w-full after:transition-all after:duration-300"
            >
              {l.label}
            </button>
          ))}
          <button
            data-testid="nav-cta-button"
            onClick={() => go("contact")}
            className="rounded-full bg-[#2D1A13] text-[#FDFBF7] text-xs font-semibold uppercase tracking-[0.15em] px-6 py-3 hover:bg-[#FF8E9E] hover:text-[#2D1A13] transition-colors duration-300"
          >
            Start a Project
          </button>
        </nav>

        <button
          data-testid="nav-mobile-toggle"
          className="md:hidden p-2"
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div data-testid="nav-mobile-menu" className="md:hidden border-t border-[#2D1A13]/10 bg-[#FDFBF7] px-6 py-6 flex flex-col gap-5">
          {links.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-mobile-link-${l.id}`}
              onClick={() => go(l.id)}
              className="text-left font-serif-display text-2xl"
            >
              {l.label}
            </button>
          ))}
          <button
            data-testid="nav-mobile-cta-button"
            onClick={() => go("contact")}
            className="rounded-full bg-[#2D1A13] text-[#FDFBF7] text-xs font-semibold uppercase tracking-[0.15em] px-6 py-4 w-fit"
          >
            Start a Project
          </button>
        </div>
      )}
    </motion.header>
  );
};
